import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { createClassroom, myClassrooms } from '../../api/class';
import { isTeacherForInstitutes } from '../../api/institute';
import { ClassForm, UserNav } from '../../components';
import { CloseOutlined } from "@ant-design/icons";
import './UserDashboard.css'

const fixedPopUp = (handleClose, teacherIn, handleInstituteSelect) => {
    return (<div className="create-fixed-popup-div">
        <div className="visible-popup-div">
            <div className="header-pop-up" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1vh' }}>
                <h3>Select the institute</h3>
                <div onClick={handleClose} className="close-popup-btn">
                    <CloseOutlined />
                </div>
            </div>
            <div className="all-institute-select-btns">
                <button className='btn btn-info' onClick={e => handleInstituteSelect('')} key='999'>No institute</button>
                {teacherIn && teacherIn.length ? (teacherIn.map((each, i) => (<button className='btn btn-primary' onClick={e => handleInstituteSelect(each.institute._id)} key={i}>{each.institute.name}</button>))) : ''}
            </div>
        </div>
    </div>)
}

const UserDashboard = () => {
    const initialVals = {
        room_ID: '',
        name: '',
        subject: '',
        section: '',
        std: '',
        institute: '',
        teachers: []
    }
    const { user } = useSelector((state) => ({ ...state }))
    const history = useHistory()
    const [loading, setLoading] = useState(true)
    const [classrooms, setClassrooms] = useState([])
    const [teacherIn, setTeacherIn] = useState([])
    const [popUp, setPopUp] = useState(false)
    const [values, setValues] = useState(initialVals)

    useEffect(() => {
        getUserClassrooms()
    }, [user])

    const getUserClassrooms = () => {
        setLoading(true)
        myClassrooms(user._id)
            .then(res => {
                setClassrooms(res.data.my_classrooms)
                getInstitutes()
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
            })
    }

    const getInstitutes = () => {
        isTeacherForInstitutes(user._id)
            .then(res => {
                setTeacherIn(res.data)
                // console.log(res.data)
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }

    const handleClose = e => {
        e.preventDefault()
        setPopUp(false)
    }

    const handleInstituteSelect = instituteID => {
        values.institute = instituteID
        createClass()
        setPopUp(false)
    }

    const handleSubmit = e => {
        e.preventDefault()
        if (teacherIn.length)
            setPopUp(true)
        else
            createClass()
    }

    const createClass = () => {
        values.teachers = [user._id]
        createClassroom(user._id, user.token, values)
            .then(res => {
                setValues(initialVals)
                toast.success("Successfully created the classroom")
                getUserClassrooms()
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
            })
    }

    const handleChange = e => {
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    const gotoMyCLassroom = classroom => {
        history.push(`/my/${classroom._id}/classroom`)
    }

    return (<div className="user-dashboard">
        {popUp ? fixedPopUp(handleClose, teacherIn, handleInstituteSelect) : ''}
        <div className="row">
            <div className="col-md-2">
                <UserNav />
            </div>
            <div className="col-md-10">
                {
                    loading ? <h1>loading</h1> : (
                        <>
                            <ClassForm values={values} handleChange={handleChange} handleSubmit={handleSubmit} />
                            <div className="all-classrooms-div" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: '5vh', justifyContent: 'space-evenly' }}>
                                {
                                    (classrooms && classrooms.length) ? (classrooms.map((each, i) => (
                                        <div key={i} style={{ minWidth: '200px', minHeight: '200px', padding: '2em' }} className="card text-center">
                                            <div className="card-body">
                                                <p className="card-text">Room-ID: {each.room_ID}</p>
                                                <h5 className="card-title">{each.name}</h5>
                                                <button onClick={e => { e.preventDefault(); gotoMyCLassroom(each) }} className="btn btn-primary">Open</button>
                                            </div>
                                        </div>
                                    ))) : <h1>No Classrooms yet, Create one</h1>
                                }
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    </div>)
};

export default UserDashboard;